export const businessList = {
  pageView: () => ({
    event_name: 'page_view',
    page_name: 'vodapay: business advance: opf:  business details: personal details: business type',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website'
  }),

  formStart: () => ({
    event_name: 'form_start',
    page_name: 'vodapay: business advance: opf:  business list',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    form_name: 'business advance: opf:  business list'
  }),

  selection: (isNewBusiness, businessName = null) => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf:  business list',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: `vodapay: business advance: opf: ${isNewBusiness ? 'select new business' : 'select existing business'}`,
    ...(businessName && { business_name: businessName })
  }),

  formEnd: (clickButton) => ({
    event_name: 'ui_interaction, form_end',
    page_name: 'vodapay: business advance: opf:  business details: personal details: business type',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    form_name: 'business advance: opf: apply business list',
    link_id: `vodapay: business advance: opf: business details: business type: ${clickButton}`
  }),

  tooltipOpen: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf:  business list : tooltip open',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: 'vodapay: business advance: opf :  business list : tooltip open'
  }),

  tooltipClose: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf:  business list : tooltip close',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: 'vodapay: business advance: opf :  business list : tooltip close'
  }),

  changeOption: (optionsValue) => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf:  business list : changed option from tooltip',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id:`vodapay: business advance: opf: business list :changed option due to ${optionsValue}`
  })
};
